//@ts-nocheck

import * as angular from "angular";
import { CredentialsManager } from "../../shared/credentials-manager";
import { SubscriptionDataProvider } from "../../data-provider/subscription.dp";
import { ProductDataProvider } from "../../data-provider/product.dp";
import { ScreenUtils } from "../../helper/screen.helper";
import { Plan } from "../../models/plan.model";

let env = {};

//Import variables if present (from env.js)
if (window) {
    angular.extend(env, window["__env"]);
}

let app = angular.module("signup", [
    "htmlTemplates",
    "ecanvasserControllers",
    "ecanvasserDirectives",
    "vcServices",
    "vcDataProvider",
    "filters",
    "ngCookies",
    "ngRoute",
    "ngSanitize",
    "theme",
    "sharedTheme",
    "whiteLabelTheme",
    "ngResource",
    "ngMaterial",
    "login",
    "credentialsManager",
    "navigation",
]);

app.config(($httpProvider: any) => {
    $httpProvider.defaults.withCredentials = true;
});

app.config([
    "$locationProvider",
    ($locationProvider: any) => {
        $locationProvider.hashPrefix("");
    },
]);

app.config(($sceDelegateProvider: any, __env: any) => {
    $sceDelegateProvider.resourceUrlWhitelist([
        // Allow same origin resource loads.
        "self",
        // Allow loading from our assets domain.  Notice the difference between * and **.
        "https://assets." + __env.host + "/**",
    ]);
});

//This makes sure that when inputs autofill with chrome, that the labels do not stay in the input causing ugly overlap
app.directive("mdInputContainer", ($timeout: any) => {
    return ($scope: any, element: any) => {
        let ua = navigator.userAgent;
        if (ua.match(/chrome/i) && !ua.match(/edge/i)) {
            $timeout(() => {
                if (element[0].querySelector("input:-webkit-autofill")) {
                    element.addClass("md-input-has-value");
                }
            }, 200);
        }
    };
});

// Register environment in AngularJS as constant
app.constant("__env", env);
app.constant("__app_type", "USER");
app.constant("__time_zone", Intl.DateTimeFormat().resolvedOptions().timeZone);

export class SignUpController {
    private readonly $scope: any;
    private readonly $http: any;
    private $window: any;
    private $location: any;
    private $cookies: any;
    private $interval: any;
    private __env: any;
    private credentialsManager: CredentialsManager;
    private subscriptionDataProvider: SubscriptionDataProvider;
    private productDataProvider: ProductDataProvider;
    private $timeout: any;

    public host: string;
    public user: any = {
        terms: false,
        marketing: false,
        ucontactnumber: "",
    };
    public campaign: any = {};
    public social_signin_loading = false;
    public currency = "";
    public viewPassword = false;
    public validating_user = false;
    public view = "user";
    public selected_plan = {};
    public verification = {};
    public authenticate = {};
    public authenticateLogin = false;
    public creatingAccount = { loading: false };
    public nocampaign = false;
    public url: any;
    public usedTrial: boolean;
    public completed: boolean | undefined;
    public email_error_message: string | undefined;
    public invite_error_message: any;
    public email_confirmation: boolean | undefined;
    public userForm: any;
    public plan_error = "";
    public cardNumberError = "";
    public error_message = "";
    public signup_error_message = "";
    public rewardful_referral_id = "";
    public plans: any = [];
    public recommendedPlan: Plan;
    public selectedInterval = "Monthly";
    public plan: Plan;
    public step: number = 1;
    public verificationCode = "";
    public verificationForm: any;
    public planSelectionActive = false;
    public login_loading: number = 0;
    public createAccountProgress: number = 10;
    public readonly screen: ScreenUtils;

    public promoCode = "";
    public promoExplainer = "";
    public promoErrors = [];
    public promoLoading = false;
    public coupon: any = null;
    public couponId: string = null;

    public selectedCoreLevel: number = 0;
    public selectedProLevel: number = 0;

    constructor(
        $scope: any,
        $http: any,
        $window: any,
        $location: any,
        $cookies: any,
        $interval: any,
        $timeout: any,
        __env: any,
        CredentialsManager: CredentialsManager,
        SubscriptionDataProvider: SubscriptionDataProvider,
        ProductDataProvider: ProductDataProvider,
        ScreenUtils: ScreenUtils
    ) {
        this.$scope = $scope;
        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$location = $location;
        this.$cookies = $cookies;
        this.$interval = $interval;
        this.__env = __env;
        this.credentialsManager = CredentialsManager;
        this.subscriptionDataProvider = SubscriptionDataProvider;
        this.productDataProvider = ProductDataProvider;
        this.screen = ScreenUtils;

        if (this.$cookies.get("rfsn")) {
            this.$location.search("rfsn", this.$cookies.get("rfsn"));
        }
        this.host = this.__env.host;

        if (this.$cookies.get("access_token") != undefined) {
            this.$window.location = window.location.origin + "/#/";
        }

        if (
            this.$cookies.get("noCampaignEmail") &&
            this.$cookies.get("noCampaignPassword")
        ) {
            this.nocampaign = true;
            this.user.noCampaignHash = this.$cookies.get("noCampaignPassword");
            this.user.noCampaignEmail = this.$cookies.get("noCampaignEmail");
            this.user.email = this.$cookies.get("noCampaignEmail");
        }

        const fullUrl = this.$location.absUrl();
        let urlParamsString = "&" + fullUrl.split("#?")[1];

        this.url = urlParamsString.split("&").reduce((res: any, item: any) => {
            let parts = item.split("=");
            res[parts[0]] = parts[1];
            return res;
        }, {});

        if (this.url.h) {
            this.user.hash = decodeURIComponent(this.url.h);
        }
        if (this.url.email) {
            this.user.email = decodeURIComponent(this.url.email);
        }

        this.$window.ga("send", {
            hitType: "event",
            eventCategory: "signup",
            eventAction: "User details form",
            eventLabel: "User details form ",
            eventValue: 1,
        });
    }

    $onInit() {
        rewardful("ready", () => {
            if (Rewardful.referral) {
                this.rewardful_referral_id = Rewardful.referral;
            }
            if (Rewardful.coupon) {
                this.coupon = Rewardful.coupon;
            }
        });

        this.subscriptionDataProvider
            .getPlans(this.campaign.campaignid, null)
            .then((plans: Plan[]) => {
                let coreMonthlyPlans: any[] = [];
                let coreYearlyPlans: any[] = [];
                let proMonthlyPlans: any[] = [];
                let proYearlyPlans: any[] = [];
                angular.forEach(plans, (plan) => {
                    if (plan.cpname.startsWith("Core")) {
                        if (plan.cpinterval == "Monthly") {
                            coreMonthlyPlans.push(plan);
                        } else {
                            coreYearlyPlans.push(plan);
                        }
                    } else if (plan.cpname.startsWith("Pro")) {
                        if (plan.cpinterval == "Monthly") {
                            proMonthlyPlans.push(plan);
                        } else {
                            proYearlyPlans.push(plan);
                        }
                    }
                });

                this.plans = {
                    core: {
                        monthly: { plans: coreMonthlyPlans },
                        yearly: { plans: coreYearlyPlans },
                    },
                    pro: {
                        monthly: { plans: proMonthlyPlans },
                        yearly: { plans: proYearlyPlans },
                    },
                };

                this.recommendedPlan = this.plans.pro;
            });

        this.$timeout(() => {
            document.getElementById("email-address").focus();
        }, 200);
    }

    checkPromoCode(code: String): void {
        this.promoExplainer = "";
        this.promoErrors = [];
        this.promoLoading = true;
        this.couponId = null;
        this.subscriptionDataProvider.checkPromoCode(code).then(
            (result) => {
                this.promoLoading = false;
                this.promoExplainer =
                    this.productDataProvider.couponDescription(result.coupon);
                this.couponId = result.coupon.id;
            },
            (data) => {
                this.promoErrors = data.message;
                this.promoLoading = false;
            }
        );
    }

    resetCode() {
        this.promoCode = "";
        this.promoExplainer = "";
        this.promoErrors = [];
        this.promoLoading = false;
        this.couponId = null;
    }

    changePlanInterval(interval: string): void {
        if (
            this.selected_plan ==
            this.plans.core[this.selectedInterval.toLowerCase()].plans[
                this.selectedCoreLevel
            ]
        ) {
            this.selected_plan =
                this.plans.core[interval.toLowerCase()].plans[
                    this.selectedCoreLevel
                ];
        } else {
            this.selected_plan =
                this.plans.pro[interval.toLowerCase()].plans[
                    this.selectedProLevel
                ];
        }
        this.selectedInterval = interval;
    }

    showResendView(): void {
        this.view = "resend";
        this.user.sentEmailAddress = angular.copy(this.user.email);
    }

    getClassPlan(campaignplan): string {
        if (this.recommendedPlan) {
            if (
                campaignplan.cpid == this.campaign.cpid &&
                this.conversionType != "create"
            ) {
                return "current-plan current-plan-style";
            } else if (campaignplan.cpname == this.recommendedPlan.cpname) {
                return "rec-plan";
            }
        }
        return "";
    }

    nextStep(): void {
        this.step += 1;

        if (this.step == 3) {
            this.$timeout(() => {
                this.$scope.$broadcast("focusPaymentDetails");
            }, 200);
        }
    }

    progress(): number {
        return ((this.step - 1) / 3) * 100;
    }

    setPlan(plan): void {
        this.subscriptionDataProvider.setupIntentSignup().then((intent) => {
            this.selectPlan(plan);
        });
    }

    verificationCodeSuccess(planName: string, interval: string): void {
        this.subscriptionDataProvider
            .getPlans(this.campaign.campaignid, null)
            .then((plans: Plan[]) => {
                angular.forEach(plans, (plan: any) => {
                    if (
                        planName == plan.cpname &&
                        interval == plan.cpinterval
                    ) {
                        this.selected_plan = plan;
                    }
                });
                this.nextStep();
            });
    }

    userFormSubmit(): void {
        if (this.user.hash && this.url.email) {
            this.createInviteAccount();
        } else {
            this.validating_user = true;
            this.invite_error_message = "";
            this.clearEmailError();
            const obj = angular.extend(this.user, this.campaign);
            if (this.coupon && this.coupon.id) {
                this.couponId = this.coupon.id;
            }
            if (this.couponId && this.couponId != "") {
                obj.promo_code = null;
                obj.coupon_code = this.couponId;
            }
            this.$http.post("/v2/user/checkEmail", obj).then(
                (response: object) => {
                    const json = response["data"];
                    this.validating_user = false;
                    if (response["data"].success) {
                        this.verification.email = this.user.email;
                        this.usedTrial = json.usedTrial;
                        this.$window.ga("send", {
                            hitType: "event",
                            eventCategory: "signup",
                            eventAction: "User details form submitted",
                            eventLabel: "Plan section ",
                            eventValue: 1,
                        });
                        this.view = "user";
                        this.step = 2;
                        this.$timeout(() => {
                            this.$scope.$broadcast("focusVerificationCode");
                        }, 200);
                    } else {
                        if (json.email) {
                            this.validateEmailError(json.email[0]);
                        } else if (json.invite) {
                            this.invite_error_message = json.invite[0];
                        }
                    }
                },
                (response: object) => {
                    this.validating_user = false;
                    const json = response["data"].data;
                    if (json.email) {
                        this.validateEmailError(json.email[0]);
                    } else if (json.invite) {
                        this.invite_error_message = json.invite[0];
                    }
                }
            );
        }
    }

    backClicked(): void {
        if (this.planSelectionActive) {
            this.planSelectionActive = false;
        } else {
            $ctrl.step = $ctrl.step - 1;
        }
    }

    selectPlan(plan: any): void {
        if (this.selected_plan && this.selected_plan.cpid) {
            this.$window.ga("send", {
                hitType: "event",
                eventCategory: "signup",
                eventAction: plan.cpname + " plan selected",
                eventLabel: "Payment section",
                eventValue: 1,
            });
        }

        if (plan == this.plans.core) {
            this.selected_plan =
                plan[this.selectedInterval.toLowerCase()].plans[
                    this.selectedCoreLevel
                ];
        } else {
            this.selected_plan =
                plan[this.selectedInterval.toLowerCase()].plans[
                    this.selectedProLevel
                ];
        }
    }

    createAccount(payment_method: any, card: any, promo_code: string): void {
        this.login_loading = 1;

        //keep the front end more interesting by changing the text
        this.$timeout(() => {
            this.login_loading = 2;
        }, 2200);

        const shouldTake = 8;
        let start = Date.now();
        //keep the front end more interesting by changing the text
        this.$interval(() => {
            if (Math.random() > 0.5) {
                var delta = (Date.now() - start) / 1000;
                let addOn =
                    Math.floor(Math.random() * 9) + (shouldTake - delta);

                if (this.createAccountProgress + addOn < 90 && addOn > 0) {
                    this.createAccountProgress += addOn;
                }
            }
        }, 400);

        this.nextStep();
        this.user.fname = card.holder_name.split(" ").slice(0, -1).join(" ");
        this.user.lname = card.holder_name.split(" ").slice(-1).join(" ");
        this.invite_error_message = null;
        this.plan_error = "";
        this.cardNumberError = "";
        this.completed = false;
        this.email_confirmation = false;
        this.campaign.payment_method = payment_method;
        let obj = angular.extend(this.user, this.campaign, this.selected_plan);
        obj.promo_code = promo_code;
        obj.rewardful_referral_id = this.rewardful_referral_id;
        obj.code = this.verification.code;
        this.creatingAccount.loading = true;
        this.$http.post("/v2/user/register", obj).then(
            (response: object) => {
                const json = response["data"].data;
                this.createAccountProgress = 90;
                if (json.success) {
                    // Only do refersion/GA when a new account is created and is not test.

                    if (!this.__env.test) {
                        // NOTE:: commented for now as users no longer have a customer id at this stage as they don't enter payment details
                        // _refersion(function(){ _rfsn._setSource("STRIPE"); _rfsn._addCart(json.customerid); });
                        this.$window.ga("send", {
                            hitType: "event",
                            eventCategory: "signup",
                            eventAction: "completed",
                            eventLabel: "create campaign on signup",
                            eventValue: 1,
                        });

                        // Create Adword Conversion event
                        gtag("event", "conversion", {
                            send_to: "AW-944082121/TY3xCOmrypQBEMmZlsID",
                        });
                    }
                    this.completed = true;
                    this.email_confirmation = json.emailconfirmation;
                    this.loginUser();
                } else {
                    if (json.type == "signin") {
                        this.error_message =
                            "An error has occurred. Please try again or contact " +
                            this.__env.support_email;
                    }
                    if (json.type == "email") {
                        this.email_error_message = json.message;
                        this.userForm.email.$setValidity("uniqueEmail", false);
                    } else if (json.type == "password") {
                        this.user.password = "";
                    } else if (json.type == "invite") {
                        this.invite_error_message = json.message;
                    } else if ((json.type = "signup")) {
                        this.signup_error_message = json.message;
                    } else if ((json.type = "code")) {
                        this.signup_error_message = json.message;
                    }
                }
            },
            () => (this.creatingAccount.loading = false)
        );
    }

    validateEmailError(message: string): void {
        this.email_error_message = message;
        this.userForm.email.$setValidity("uniqueEmail", false);
    }

    clearEmailError(): void {
        this.email_error_message = "";
        this.userForm.email.$setValidity("uniqueEmail", true);
    }

    createInviteAccount(region?: string): void {
        this.creatingAccount.loading = true;
        let host = "/v2";
        if (angular.isDefined(region)) {
            host = "https://" + region + "." + this.__env.host + "/v2";
        }

        this.$http.post(host + "/user/invite", this.user).then(
            (response: object) => {
                const json = response["data"];
                this.creatingAccount.loading = false;
                if (json.success) {
                    this.successRedirect(region);
                } else if (response["data"].setupAuthNeeded) {
                    this.authenticate = {
                        image: response["data"].imgSrc,
                        secret: response["data"].secret,
                        setup: true,
                        region: region,
                        key: response["data"].authKey || null,
                        email: this.user.email,
                    };
                    this.authenticateLogin = true;
                } else {
                    if (angular.isDefined(json.region)) {
                        this.createInviteAccount(json.region);
                    } else {
                        this.invite_error_message = json.message;
                    }
                }
            },
            () => (this.creatingAccount.loading = false)
        );
    }

    successRedirect(region?: string): void {
        this.credentialsManager.redirect(
            "login",
            this.$cookies.get("campaignid"),
            region
        );
    }

    reset(): void {
        this.view = "user";
    }

    loginUser(region: string): void {
        this.login_loading = 3;

        // * property name was changed just to keep the string clear * //
        let url = this.__env.apiUrl();
        if (angular.isDefined(region)) {
            url =
                "https://" +
                region +
                "." +
                this.__env.host +
                this.__env.apiUrl();
        }

        this.createAccountProgress = 95;

        this.$http
            .post(
                url + "/login?timezone=" + encodeURIComponent(this.__time_zone),
                {
                    email: this.user.email,
                    password: this.user.password,
                }
            )
            .then(
                (response: object) => {
                    this.createAccountProgress = 100;
                    if (response["data"].success) {
                        this.creatingAccount.loading = false;
                        this.credentialsManager.redirect(
                            "login",
                            this.$cookies.get("campaignid"),
                            region,
                            "welcome"
                        );
                    } else if (angular.isDefined(response["data"].region)) {
                        this.loginUser(response["data"].region);
                    } else {
                        this.error = response["data"].message;
                        this.errorName = response["data"].error;

                        this.creatingAccount.loading = false;
                        this.login_loading = 0;
                    }
                },
                () => {
                    this.error = "An error has occurred";

                    this.creatingAccount.loading = false;
                    this.login_loading = 0;
                }
            );
    }

    confirmPlan(): void {
        this.planSelectionActive = false;
        if (this.plans.core == plan) {
            this.selected_plan =
                plan[this.selectedInterval].plans[this.selectedCoreLevel];
        } else {
            this.selected_plan =
                plan[this.selectedInterval].plans[this.selectedProLevel];
        }
    }
}

app.controller("SignUpController", SignUpController);
